import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

const mutation = gql`
  mutation facilityInsuranceUpdate(
    $location_uuid: String!
    $add_uids: [String!]
    $remove_uids: [String!]
    $employee_id: ID
  ) {
    facilityInsuranceUpdate(
      location_uuid: $location_uuid
      add_uids: $add_uids
      remove_uids: $remove_uids
      employee_id: $employee_id
    ) {
      id
    }
  }
`

export default function useFacilityInsuranceUpdate() {
  const { onMutate: onFacilityInsuranceUpdate, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'facilityInsuranceUpdate',
    successMessage: 'Facility insurance updated'
  })

  return { onFacilityInsuranceUpdate, loading }
}
